<template>
    <div class="modalStatsWrapper">
        <ModalPlayerLayout :closeModal="this.closeStatsModal">
            <template v-slot:default>
                <div class="modal_container" :style="{ width: '400px' , height: '100%' , margin: '-12px 0 0 0 ' }">
                    <div class="statsModal">
                        <table>
                            <tbody>
                                <tr class="stats">
                                    <td class="statsKey">
                                        <span class="statsTitle">Vidéo</span>
                                    </td>

                                    <td>
                                        <span class="statsValue">
                                            {{ mediaId }}
                                        </span>
                                    </td>
                                </tr>

                                <tr class="stats">
                                    <td class="statsKey">
                                        <span class="statsTitle">Fenêtre</span>
                                    </td>

                                    <td>
                                        <span class="statsValue">
                                            {{' '}}
                                            {{clientHeight}} x {{clientWidth}}{{' '}}
                                        </span>
                                    </td>
                                </tr>
                                <tr class="stats">
                                    <td class="statsKey">
                                        <span class="statsTitle">Résolution actuelle</span>
                                    </td>

                                    <td>
                                        <span class="statsValue">
                                            {{' '}}
                                            {{videoHeight}} x {{videoWidth}}{{' '}}
                                        </span>
                                    </td>
                                </tr>
                                <tr class="stats">
                                    <td class="statsKey">
                                        <span class="statsTitle">Volume</span>
                                    </td>

                                    <td>
                                        <span class="statsValue">{{ volume }}%</span>
                                    </td>
                                </tr>
                                <tr class="stats">
                                    <td class="statsKey">
                                        <span class="statsTitle">Codec</span>
                                    </td>

                                    <td>
                                        <span class="statsValue">
                                            {{ codec }}
                                        </span>
                                    </td>
                                </tr>
                                <tr class="stats">
                                    <td class="statsKey">
                                        <span class="statsTitle">Hôte</span>
                                    </td>
                                    <td>
                                        <span class="statsValue">empreinte</span>
                                    </td>
                                </tr>
                                <tr class="stats">
                                    <td class="statsKey">
                                        <span class="statsTitle">Vitesse</span>
                                    </td>

                                    <td>
                                        <span class="statsValue">
                                            100
                                            Kbps
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
        </ModalPlayerLayout>
    </div>
</template>
    
<script>
import ModalPlayerLayout from '../../layout/ModalPlayerLayout/ModalPlayerLayout.vue';
export default {

    name: 'StatsModal',
    components: {
        ModalPlayerLayout
    },
    props: {
        videoData: {
            type: Object
        },
        player: {
            type: Object
        },
        closeStatsModal: {
            type: Function
        }
    },
    data() {
        return {
            mediaId: "",
            codec: "",
            clientWidth: "",
            clientHeight: "",
            videoWidth: "",
            videoHeight: "",
            volume: "",
        }
    },
    mounted() {
        this.mediaId = this.videoData.playerOptions.mediaId;
        this.codec = this.videoData.generalInfo?.codec_name?.video;
        this.clientWidth = this.player.clientWidth;
        this.clientHeight = this.player.clientHeight;
        this.videoWidth = this.player.videoWidth;
        this.videoHeight = this.player.videoHeight;
        this.volume = (this.player?.volume * 100).toFixed(2);
    }
}
</script>
  
<style>
.modalStatsWrapper .wrapper {
    width: 30% !important;
}

.statsModal {
    height: 100%;
    position: absolute;
    font-family: "Open Sans";
    width: 90%;
}

.statsModal table {
    border-collapse: collapse;
    width: 100%;
    margin-top: 25%;
}

.statsModal tr {
    border-bottom: var(--vm-modal-stats-border);
}

.statsModal .stats td {
    padding: 8px 80px 3px 0;
}

.statsModal .stats .statsKey {
    text-align: right !important;
    padding-right: 15px !important;
}

.statsModal .stats .statsTitle {
    color: var(--vm-modal-font-color);
    font-family: "Open Sans";
    font-size: 12px;
    font-weight: 600;
}

.statsModal .stats .statsValue {
    font-size: 13px;
    text-align: center;
    color: var(--vm-modal-font-color);
    font-family: "Open Sans";
}
</style>